"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

/**
 * All action "namespaces" for the action types used in crm_data.
 * For examples, the name spaces of "SOMETHING_FETCH_STARTED" is "SOMETHING" and
 * should be declared here.
 *
 * These keys should be in _ABC order_.
 */
var _default = (0, _keyMirror.default)({
  LEGACY_ACTIVE_OWNERS: null,
  ACCOUNTING_EXTENSIONS: null,
  ACCOUNTING_PRODUCTS: null,
  ACCOUNTING_PRODUCTS_SEARCH: null,
  ACCOUNTING_CUSTOMERS: null,
  ACCOUNTING_INVOICES: null,
  ACCOUNTING_TERMS: null,
  ACCOUNTS: null,
  ACTIVITY_TYPES: null,
  ASSOCIATED_OPEN_OBJECTS: null,
  ASSOCIATIONS: null,
  ASSOCIATIONS_DEFINITIONS: null,
  ASSOCIATIONS_FIRST_PAGE: null,
  BET_PORTAL_OBJECT_ASSOCIATIONS: null,
  BET_SERVICE_OBJECT_ASSOCIATIONS: null,
  BIDEN: null,
  BLACKLIST_DOMAINS: null,
  BRANDING: null,
  CALLEE: null,
  CALL_DISPOSITIONS: null,
  CALL_PROVIDERS: null,
  CALL_TRANSCRIPTIONS: null,
  CAMPAIGNS: null,
  COMMUNICATOR: null,
  COMPANIES: null,
  COMPANY_CHILDREN: null,
  CRM_CONNECTED_ACCOUNTS: null,
  CONTACTS: null,
  CONTENTS: null,
  CONVERSATIONS: null,
  CREATOR_PROPERTIES: null,
  CURRENT_OWNER_ID: null,
  DEAL_AUTOMATION: null,
  DEAL_AUTOMATION_ACTION: null,
  DEAL_PIPELINE_SEARCH: null,
  DEAL_PIPELINES: null,
  DEAL_STAGE_PROPERTIES: null,
  DEALS: null,
  DECKS: null,
  DOUBLE_OPT_IN: null,
  EMAIL_CAMPAIGNS: null,
  EMAIL_INTEGRATIONS: null,
  EMAIL_PROVIDER: null,
  EMAIL_PROVIDER_BY_DOMAIN: null,
  EMAIL_RECIPIENT_DELIVERABILTY: null,
  EMAIL_SUBSCRIPTIONS: null,
  EMAIL_TRACKING_BY_TRACKER_KEY: null,
  EMAIL_TRACKING_BY_MESSAGE_ID: null,
  EMAIL_UNBOUNCE_EVENTS: null,
  EMAIL_UNBOUNCE: null,
  EMAIL_UNSUBSCRIBE_LINK: null,
  TIMELINE_COMMENT: null,
  ENGAGEMENTS: null,
  ENGAGEMENT_BODY: null,
  ENROLLMENTS: null,
  ES: null,
  FAVORITE_LISTS: null,
  FAVORITE_VIEWS_USER: null,
  FEEDBACK_SUBMISSIONS: null,
  FORMS: null,
  FOLLOW_PROFILE: null,
  GATES: null,
  GENERIC_INBOX_SETTINGS: null,
  GOTOWEBINAR_SETTINGS: null,
  GRID_VIEW_SELECTION_EDITABLE_COUNT: null,
  HAS_EMAIL_ENGAGEMENTS: null,
  IMPORT_NAMES: null,
  INTEGRATION_NAME: null,
  IP: null,
  JOIN_ME_USER: null,
  LINE_ITEMS: null,
  LINE_ITEMS_BULK: null,
  LINKED_IN_NAVIGATOR: null,
  LIST_REFS: null,
  LIST_USAGE: null,
  LISTS_HAS_STATIC: null,
  LISTS_SEARCH: null,
  LISTS: null,
  LOCALSETTINGS: null,
  KNOWLEDGEARTICLES: null,
  MEETINGS_LINKS: null,
  MEETINGS_USER: null,
  MULTI_CURRENCY: null,
  MULTI_CURRENCY_SETTINGS: null,
  NEVER_LOG: null,
  NOTIFICATION_PREFERENCES: null,
  O365_ADDIN: null,
  OBJECT_CREATOR_PROPERTIES: null,
  OUTLOOK_PLUGIN: null,
  OWNER_IDS_BY_EMAIL: null,
  OWNER_IDS_BY_REMOTE_ID: null,
  OWNERS: null,
  OWNERS_SEARCH: null,
  PERSONAS: null,
  PINNED_ENGAGEMENT: null,
  PIPELINE_DETAILS: null,
  PLAYBOOKS: null,
  PORTAL_FULL: null,
  PREDICTIVE_SCORE: null,
  PRODUCTS_BY_ID: null,
  PRODUCTS_SEARCH: null,
  PRODUCTS_SEARCH_LOAD_MORE: null,
  PRODUCTS: null,
  PROPERTIES: null,
  PROSPECT_FAVORITES: null,
  QUOTE_AUTOMATION: null,
  QUOTE_BY_ID: null,
  QUOTES: null,
  QUOTES_BY_DEAL_ID: null,
  QUOTES_SETTINGS: null,
  CONTENT_REGISTERED_CONTACTS: null,
  RELATED_ITEMS_ASSOCIATIONS: null,
  RESTRICTED_CONTENTS_BY_LIST: null,
  RESTRICTED_CONTENTS_BY_CONTACT: null,
  SALESFORCE_RATE_LIMIT: null,
  SALESFORCE_INCLUSION_LIST: null,
  SEGMENT_FILTERS: null,
  SEGMENTS_CONTACT_MATCH_CHECK: null,
  SEGMENTS_DEPENDENT_WORKFLOWS: null,
  SEGMENTS_FOLDERS: null,
  SEGMENTS_SEARCH: null,
  SEGMENTS: null,
  SETTINGS: null,
  SEQUENCE_ENROLLMENT_LIMIT: null,
  SFDC_METADATA: null,
  SFDC_OBJECT: null,
  SFDC_RATE_LIMIT: null,
  SIDEBAR_INTEGRATIONS: null,
  SIDEKICK_SETTINGS: null,
  SIDEKICK_PORTAL: null,
  SIGNED_FILES: null,
  SNIPPETS: null,
  STRIPE_INTEGRATION: null,
  STRIPE_PORTAL_TYPE: null,
  SUBSCRIPTIONS: null,
  SUBSCRIPTIONS_BY_EMAIL: null,
  SUBSCRIPTION_DEFINITIONS: null,
  SURVEY_MONKEY: null,
  SURVEY_MONKEY_SETTINGS: null,
  TASK_PIPELINE_SEARCH: null,
  TEAMS: null,
  TEAM_OWNER: null,
  TICKETS: null,
  TICKET_AUTOMATION: null,
  TICKET_FORMS: null,
  TICKET_PIPELINE_SEARCH: null,
  TICKET_PIPELINE_CONTENTS: null,
  TICKET_PIPELINES: null,
  TICKET_STAGE_PROPERTIES: null,
  TIMELINE_FILTERS: null,
  TIMELINE_INTEGRATION: null,
  USERS: null,
  USERSETTINGS: null,
  USER_ATTRIBUTES: null,
  VISITS: null,
  WORKFLOWS: null,
  PAID_HUB: null,
  PORTAL_TRIAL_STATE: null,
  VIDEO_CONFERENCE: null,
  VIDYARD: null
});

exports.default = _default;
module.exports = exports.default;